// ---------- Slick Sliders ---------- //
//Header Mobile - USPS
$(document).ready(function(){
    $('.nav-usps-mobile-thin-slider').slick({
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1
    });
});

$(document).ready(function(){
    $('.nav-usps-mobile-slider').slick({
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1
    });
});

//Index Main Slider
$(document).ready(function(){
    $('.index-slider').slick({
        dots: true,
        appendDots: '.index-dots',
        infinite: true,
        arrows: false,
        fade: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear'
    });
});


//Index Product Slider
$(document).ready(function(){
    $('.index-slider-product').slick({
        infinite: true,
        arrows: true,
        prevArrow: $('.index-slider-product-prev'),
        nextArrow: $('.index-slider-product-next'),
        fade: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1
    });
});

//Showroom Slider
$(document).ready(function(){
    $('.showroom-slider').slick({
        slide: '.showroom-slide',
        infinite: true,
        arrows: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1
    });
});

//Category Form Slider 
$(document).ready(function(){
    $('.category-form-slider').slick({
        infinite: false,
        arrows: true,
        fade: true,
        prevArrow: $('.form-prev'),
        nextArrow: $('.form-next'),
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
    });
});


//Pop Up Form Generic Slider
$(document).ready(function () {
    $('.pop-up-form-generic-slider').slick({
        infinite: false,
        arrows: true,
        fade: true,
        prevArrow: $('.pop-up-form-generic .form-prev'),
        nextArrow: $('.pop-up-form-generic .form-next'),
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
    });
});

//Pop Up Form Scooter Slider
$(document).ready(function () {
    $('.pop-up-form-scooter-slider').slick({
        infinite: false,
        arrows: true,
        fade: true,
        prevArrow: $('.pop-up-form-scooter .form-prev'),
        nextArrow: $('.pop-up-form-scooter .form-next'),
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
    });
});

//Pop Up Form Chair Slider
$(document).ready(function () {
    $('.pop-up-form-chair-slider').slick({
        infinite: false,
        arrows: true,
        fade: true,
        prevArrow: $('.pop-up-form-chair .form-prev'),
        nextArrow: $('.pop-up-form-chair .form-next'),
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
    });
});

//Pop Up Form Bed Slider
$(document).ready(function () {
    $('.pop-up-form-bed-slider').slick({
        infinite: false,
        arrows: true,
        fade: true,
        prevArrow: $('.pop-up-form-bed .form-prev'),
        nextArrow: $('.pop-up-form-bed .form-next'),
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
    });
});

//Product Page Slider
$('.product-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.product-slider-nav'
});

//Nav for Product Page Slider
$('.product-slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.product-slider',
    centerMode: true,
    centerPadding: '0',
    focusOnSelect: true
});

// get slide of slides for slick slides (Index Product Slider)
$(document).ready(function(){
    var $statusSlide = $('.status-slide');
    var $statusOf = $('.status-of');
    var $slickElement = $('.index-slider-product');

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        var sc = ($slickElement).slick("getSlick").slideCount;
        $statusSlide.text(i);
        $statusOf.text(sc);
    });

    $slickElement.slick({
        slide: 'img',
        autoplay: true,
        dots: true
    });
});

// get slide of slides for slick slides (Category Form)
$(document).ready(function(){
    var $statusSlide = $('.status-slide');
    var $statusOf = $('.status-of');
    var $slickElement = $('.category-form-slider');

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        var sc = ($slickElement).slick("getSlick").slideCount;
        $statusSlide.text(i);
        $statusOf.text(sc);
    });

    $slickElement.slick({
        slide: 'img',
        autoplay: true,
        dots: true
    });
});

// get slide of slides for slick slides (Pop Up Generic Form)
$(document).ready(function () {
    var $statusSlide = $('.status-slide-generic-pop-up');
    var $statusOf = $('.status-of-generic-pop-up');
    var $slickElement = $('.pop-up-form-generic-slider');

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        var sc = ($slickElement).slick("getSlick").slideCount;
        $statusSlide.text(i);
        $statusOf.text(sc);
    });

    $slickElement.slick({
        slide: 'img',
        autoplay: true,
        dots: true
    });
});

// get slide of slides for slick slides (Pop Up Scooter Form)
$(document).ready(function () {
    var $statusSlide = $('.status-slide-scooter-pop-up');
    var $statusOf = $('.status-of-scooter-pop-up');
    var $slickElement = $('.pop-up-form-scooter-slider');

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        var sc = ($slickElement).slick("getSlick").slideCount;
        $statusSlide.text(i);
        $statusOf.text(sc);
    });

    $slickElement.slick({
        slide: 'img',
        autoplay: true,
        dots: true
    });
});

// get slide of slides for slick slides (Pop Up Chair Form)
$(document).ready(function () {
    var $statusSlide = $('.status-slide-chair-pop-up');
    var $statusOf = $('.status-of-chair-pop-up');
    var $slickElement = $('.pop-up-form-chair-slider');

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        var sc = ($slickElement).slick("getSlick").slideCount;
        $statusSlide.text(i);
        $statusOf.text(sc);
    });

    $slickElement.slick({
        slide: 'img',
        autoplay: true,
        dots: true
    });
});

// get slide of slides for slick slides (Pop Up Bed Form)
$(document).ready(function () {
    var $statusSlide = $('.status-slide-bed-pop-up');
    var $statusOf = $('.status-of-bed-pop-up');
    var $slickElement = $('.pop-up-form-bed-slider');

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        var sc = ($slickElement).slick("getSlick").slideCount;
        $statusSlide.text(i);
        $statusOf.text(sc);
    });

    $slickElement.slick({
        slide: 'img',
        autoplay: true,
        dots: true
    });
});

// Progress bar (Category Form)
$(document).ready(function() {
    var $slider = $('.category-form-slider');
    var $progressBar = $('.progress');
    
    $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
      var calc = ( (nextSlide + 1) / (slick.slideCount) ) * 100;
      
      $progressBar
        .css('background-size', calc +  '% 100%')
        .attr('aria-valuenow', calc );
      
    });
});

// Progress bar (Pop Up Generic Form)
$(document).ready(function () {
    var $slider = $('.pop-up-form-generic-slider');
    var $progressBar = $('.progress-generic-pop-up');

    $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var calc = ((nextSlide + 1) / (slick.slideCount)) * 100;

        $progressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc);

    });
});

// Progress bar (Pop Up Scooter Form)
$(document).ready(function () {
    var $slider = $('.pop-up-form-scooter-slider');
    var $progressBar = $('.progress-scooter-pop-up');

    $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var calc = ((nextSlide + 1) / (slick.slideCount)) * 100;

        $progressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc);

    });
});

// Progress bar (Pop Up Chair Form)
$(document).ready(function () {
    var $slider = $('.pop-up-form-chair-slider');
    var $progressBar = $('.progress-chair-pop-up');

    $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var calc = ((nextSlide + 1) / (slick.slideCount)) * 100;

        $progressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc);

    });
});

// Progress bar (Pop Up Bed Form)
$(document).ready(function () {
    var $slider = $('.pop-up-form-bed-slider');
    var $progressBar = $('.progress-bed-pop-up');

    $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var calc = ((nextSlide + 1) / (slick.slideCount)) * 100;

        $progressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc);

    });
});

// ---------- Pop Up Forms ---------- //
// Generic
$(document).ready(function () {
    $("#main-header-brochure, #core-ctas-brochure-request").on("click", function (e) {
        e.preventDefault();
            $("#pop-up-form-generic").addClass("modal-pop-show");
            $("#lights-out").addClass("lights-out-on");
            $("body").addClass("active-menu");
            $("#prevent-scrolling").addClass("prevent-scrolling");
    });
});

$(document).ready(function () {
    $("#pop-up-form-generic-close").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-form-generic").removeClass("modal-pop-show");
        $("#lights-out").removeClass("lights-out-on");
        $("body").removeClass("active-menu");
        $("#prevent-scrolling").removeClass("prevent-scrolling");
    });
});

//Generic from mobile menu
$(document).ready(function () {
    $("#side-nav-brochure-request").on("click", function (e) {
        e.preventDefault();
        $("#side-nav-main").removeClass("side-nav-open");
        $("#side-nav-main").addClass("side-nav-closed");
        $("#side-nav-close").addClass("hide");
        $("#pop-up-form-generic").addClass("modal-pop-show");
        $("#prevent-scrolling").addClass("prevent-scrolling");
    });
});

///Scooter
$(document).ready(function () {
    $("#category-brochure-button-mobile-scooter, #product-scooter-brochure").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-form-scooter").addClass("modal-pop-show");
        $("#lights-out").addClass("lights-out-on");
        $("body").addClass("active-menu");
        $("#prevent-scrolling").addClass("prevent-scrolling");
    });
});

$(document).ready(function () {
    $("#pop-up-form-scooter-close").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-form-scooter").removeClass("modal-pop-show");
        $("#lights-out").removeClass("lights-out-on");
        $("body").removeClass("active-menu");
        $("#prevent-scrolling").removeClass("prevent-scrolling");
    });
});

///Chair
$(document).ready(function () {
    $("#category-brochure-button-mobile-chair, #product-chair-brochure").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-form-chair").addClass("modal-pop-show");
        $("#lights-out").addClass("lights-out-on");
        $("body").addClass("active-menu");
        $("#prevent-scrolling").addClass("prevent-scrolling");
    });
});

$(document).ready(function () {
    $("#pop-up-form-chair-close").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-form-chair").removeClass("modal-pop-show");
        $("#lights-out").removeClass("lights-out-on");
        $("body").removeClass("active-menu");
        $("#prevent-scrolling").removeClass("prevent-scrolling");
    });
});

///Bed
$(document).ready(function () {
    $("#category-brochure-button-mobile-bed, #product-bed-brochure").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-form-bed").addClass("modal-pop-show");
        $("#lights-out").addClass("lights-out-on");
        $("body").addClass("active-menu");
        $("#prevent-scrolling").addClass("prevent-scrolling");
    });
});

$(document).ready(function () {
    $("#pop-up-form-bed-close").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-form-bed").removeClass("modal-pop-show");
        $("#lights-out").removeClass("lights-out-on");
        $("body").removeClass("active-menu");
        $("#prevent-scrolling").removeClass("prevent-scrolling");
    });
});


///Pop Up Out of Area Store

//(only close is here as this is triggered in jquery.storelocator.js file)
$(document).ready(function () {
    $("#pop-up-store-out-of-area-close").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-store-out-of-area").removeClass("modal-pop-show");
        $("#lights-out").removeClass("lights-out-on");
        $("body").removeClass("active-menu");
        $("#prevent-scrolling").removeClass("prevent-scrolling");
    });
});

///Pop Up Out of Area Store - go to brochure pop up
$(document).ready(function () {
    $("#pop-up-store-out-of-area-brochure").on("click", function (e) {
        e.preventDefault();
        $("#pop-up-store-out-of-area").removeClass("modal-pop-show");
        $("#pop-up-form-generic").addClass("modal-pop-show");

    });
});


// ---------- Side Menu ---------- //
// Set height of mobile side nav to inner window - for iPhone 10, etc
$(document).ready(function(){
    function resize(){
        var heights = window.innerHeight;
        document.getElementById("side-nav-main").style.height = heights + "px";
    }
    resize();
    window.onresize = function() {
        resize();
    };
});

$(document).ready(function(){
    function resize(){
        var heights = window.innerHeight;
        document.getElementById("side-nav-index").style.height = (heights - 242) + "px";
    }
    resize();
    window.onresize = function() {
        resize();
    };
});

$(document).ready(function(){
    function resize(){
        var heights = window.innerHeight;
        document.getElementById("side-nav-overflow-chairs").style.height = (heights - 352) + "px";
    }
    resize();
    window.onresize = function() {
        resize();
    };
});

$(document).ready(function(){
    function resize(){
        var heights = window.innerHeight;
        document.getElementById("side-nav-overflow-beds").style.height = (heights - 345) + "px";
    }
    resize();
    window.onresize = function() {
        resize();
    };
});

$(document).ready(function(){
    function resize(){
        var heights = window.innerHeight;
        document.getElementById("side-nav-overflow-scooters").style.height = (heights - 345) + "px";
    }
    resize();
    window.onresize = function() {
        resize();
    };
});

$(document).ready(function(){
    function resize(){
        var heights = window.innerHeight;
        document.getElementById("side-nav-overflow-scooters").style.height = (heights - 345) + "px";
    }
    resize();
    window.onresize = function() {
        resize();
    };
});

// Side Menu Accordian
$(document).ready(function(){
    var acc = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight){
        panel.style.maxHeight = null;
        } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
        } 
    });
    }
});


// ---------- Slide Down Main Menu ---------- //
$("#hover-about").hover(
    function () {
        $("#expand-about").addClass("vao");
        $("#hover-about").addClass("hover-generic");
        $("#hover-about > .nav-arrow-pewter").addClass("hide");
        $("#hover-about > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        $("#expand-about").removeClass("vao");
        $("#hover-about").removeClass("hover-generic");
        $("#hover-about > .nav-arrow-pewter").removeClass("hide");
        $("#hover-about > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#expand-about").hover(
    function () {
        $("#expand-about").addClass("vao");
        $("#hover-about").addClass("hover-generic");
        $("#hover-about > .nav-arrow-pewter").addClass("hide");
        $("#hover-about > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        $("#expand-about").removeClass("vao");
        $("#hover-about").removeClass("hover-generic");
        $("#hover-about > .nav-arrow-pewter").removeClass("hide");
        $("#hover-about > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#hover-chairs").hover(
    function () {
        $("#expand-chairs").addClass("vao");
        $("#hover-chairs").addClass("hover-chairs");
        $("#hover-chairs > .nav-arrow-pewter").addClass("hide");
        $("#hover-chairs > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        $("#expand-chairs").removeClass("vao");
        $("#hover-chairs").removeClass("hover-chairs");
        $("#hover-chairs > .nav-arrow-pewter").removeClass("hide");
        $("#hover-chairs > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#expand-chairs").hover(
    function () {
        $("#expand-chairs").addClass("vao");
        $("#hover-chairs").addClass("hover-chairs");
        $("#hover-chairs > .nav-arrow-pewter").addClass("hide");
        $("#hover-chairs > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        $("#expand-chairs").removeClass("vao");
        $("#hover-chairs").removeClass("hover-chairs");
        $("#hover-chairs > .nav-arrow-pewter").removeClass("hide");
        $("#hover-chairs > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#hover-beds").hover(
    function () {
        $("#expand-beds").addClass("vao");
        $("#hover-beds").addClass("hover-beds");
        $("#hover-beds > .nav-arrow-pewter").addClass("hide");
        $("#hover-beds > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        $("#expand-beds").removeClass("vao");
        $("#hover-beds").removeClass("hover-beds");
        $("#hover-beds > .nav-arrow-pewter").removeClass("hide");
        $("#hover-beds > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#expand-beds").hover(
    function () {
        $("#expand-beds").addClass("vao");
        $("#hover-beds").addClass("hover-beds");
        $("#hover-beds > .nav-arrow-pewter").addClass("hide");
        $("#hover-beds > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        $("#expand-beds").removeClass("vao");
        $("#hover-beds").removeClass("hover-beds");
        $("#hover-beds > .nav-arrow-pewter").removeClass("hide");
        $("#hover-beds > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#hover-scooters").hover(
    function () {
        $("#expand-scooters").addClass("vao");
        $("#hover-scooters").addClass("hover-scooters");
        $("#hover-scooters > .nav-arrow-pewter").addClass("hide");
        $("#hover-scooters > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        $("#expand-scooters").removeClass("vao");
        $("#hover-scooters").removeClass("hover-scooters");
        $("#hover-scooters > .nav-arrow-pewter").removeClass("hide");
        $("#hover-scooters > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#expand-scooters").hover(
    function () {
        $("#expand-scooters").addClass("vao");
        $("#hover-scooters").addClass("hover-scooters");
        $("#hover-scooters > .nav-arrow-pewter").addClass("hide");
        $("#hover-scooters > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        $("#expand-scooters").removeClass("vao");
        $("#hover-scooters").removeClass("hover-scooters");
        $("#hover-scooters > .nav-arrow-pewter").removeClass("hide");
        $("#hover-scooters > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#hover-offers").hover(
    function () {
        $("#expand-offers").addClass("vao");
        $("#hover-offers").addClass("hover-offers");
        $("#hover-offers > .nav-arrow-pewter").addClass("hide");
        $("#hover-offers > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        $("#expand-offers").removeClass("vao");
        $("#hover-offers").removeClass("hover-offers");
        $("#hover-offers > .nav-arrow-pewter").removeClass("hide");
        $("#hover-offers > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#expand-offers").hover(
    function () {
        $("#expand-offers").addClass("vao");
        $("#hover-offers").addClass("hover-offers");
        $("#hover-offers > .nav-arrow-pewter").addClass("hide");
        $("#hover-offers > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        $("#expand-offers").removeClass("vao");
        $("#hover-offers").removeClass("hover-offers");
        $("#hover-offers > .nav-arrow-pewter").removeClass("hide");
        $("#hover-offers > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#hover-help").hover(
    function () {
        $("#expand-help").addClass("vao");
        $("#hover-help").addClass("hover-generic");
        $("#hover-help > .nav-arrow-pewter").addClass("hide");
        $("#hover-help > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        $("#expand-help").removeClass("vao");
        $("#hover-help").removeClass("hover-generic");
        $("#hover-help > .nav-arrow-pewter").removeClass("hide");
        $("#hover-help > .nav-arrow-white").removeClass("show-arrow");
    }
);

$("#expand-help").hover(
    function () {
        $("#expand-help").addClass("vao");
        $("#hover-help").addClass("hover-generic");
        $("#hover-help > .nav-arrow-pewter").addClass("hide");
        $("#hover-help > .nav-arrow-white").addClass("show-arrow");
    }, 
    function () {
        $("#expand-help").removeClass("vao");
        $("#hover-help").removeClass("hover-generic");
        $("#hover-help > .nav-arrow-pewter").removeClass("hide");
        $("#hover-help > .nav-arrow-white").removeClass("show-arrow");
    }
);

// ---------- Main Nav Menus ---------- //
//Open menu on menu button click
$(document).ready(function () {
	$("#nav-cta-mobile-menu").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-main").hasClass("side-nav-closed")) {
            $("#side-nav-main").addClass("side-nav-open");
            $("#side-nav-main").removeClass("side-nav-closed");
            $("#lights-out").addClass("lights-out-on");
            $("#side-nav-close").removeClass("hide");
            $("#prevent-scrolling").addClass("prevent-scrolling");
		}
		else if($("#side-nav-main").hasClass("open-slide")) {
			
		}
	});
});

//Close menu on 'x' button click
$(document).ready(function () {
	$("#side-nav-close").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-main").hasClass("side-nav-open")) {
            $("#side-nav-main").removeClass("side-nav-open");
            $("#side-nav-main").addClass("side-nav-closed");
            $("#lights-out").removeClass("lights-out-on");
            $("#side-nav-close").addClass("hide");
            $("#prevent-scrolling").removeClass("prevent-scrolling");
            $("#side-nav-beds").addClass("side-nav-closed");
            $("#side-nav-beds").removeClass("side-nav-open");
            $("#side-nav-chairs").addClass("side-nav-closed");
            $("#side-nav-chairs").removeClass("side-nav-open");
            $("#side-nav-scooters").addClass("side-nav-closed");
            $("#side-nav-scooters").removeClass("side-nav-open");
		}
		else if($("#side-nav-main").hasClass("open-slide")) {
			
		}
	});
});

//Open chairs menu
$(document).ready(function () {
	$("#side-nav-item-chairs").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-chairs").hasClass("side-nav-closed")) {
            $("#side-nav-chairs").addClass("side-nav-open");
            $("#side-nav-chairs").removeClass("side-nav-closed");
		}
		else if($("#side-nav-chairs").hasClass("open-slide")) {
			
		}
	});
});

//Close chairs menu
$(document).ready(function () {
	$("#all-departments-chairs").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-chairs").hasClass("side-nav-open")) {
            $("#side-nav-chairs").addClass("side-nav-closed");
            $("#side-nav-chairs").removeClass("side-nav-open");
		}
		else if($("#side-nav-chairs").hasClass("open-slide")) {
			
		}
	});
});

//Open beds menu
$(document).ready(function () {
	$("#side-nav-item-beds").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-beds").hasClass("side-nav-closed")) {
            $("#side-nav-beds").addClass("side-nav-open");
            $("#side-nav-beds").removeClass("side-nav-closed");
		}
		else if($("#side-nav-beds").hasClass("open-slide")) {
			
		}
	});
});

//Close beds menu
$(document).ready(function () {
	$("#all-departments-beds").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-beds").hasClass("side-nav-open")) {
            $("#side-nav-beds").addClass("side-nav-closed");
            $("#side-nav-beds").removeClass("side-nav-open");
		}
		else if($("#side-nav-beds").hasClass("open-slide")) {
			
		}
	});
});

//Open scooters menu
$(document).ready(function () {
	$("#side-nav-item-scooters").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-scooters").hasClass("side-nav-closed")) {
            $("#side-nav-scooters").addClass("side-nav-open");
            $("#side-nav-scooters").removeClass("side-nav-closed");
		}
		else if($("#side-nav-scooters").hasClass("open-slide")) {
			
		}
	});
});

//Close scooters menu
$(document).ready(function () {
	$("#all-departments-scooters").on("click", function(e){
			e.preventDefault();
		if($("#side-nav-scooters").hasClass("side-nav-open")) {
            $("#side-nav-scooters").addClass("side-nav-closed");
            $("#side-nav-scooters").removeClass("side-nav-open");
		}
		else if($("#side-nav-scooters").hasClass("open-slide")) {
			
		}
	});
});


// ---------- Showroom Slider ---------- //
//Expand slider on button press 
$(document).ready(function () {
	$("#showroom-slider-button").on("click", function(e){
            e.preventDefault();
            $("#header-desktop-inner-main").addClass("hide-op");
            
            $("#showroom-slider-button").addClass("hide-op");
            setTimeout(function(){
                $('.showroom-slide').css('margin-top', '0');
                $("#header-desktop").addClass("translate-dt-head-up");
                $("#showroom-slider").addClass("translate-dt-head-up");
                $("#showroom-slider").addClass("showroom-slider-open");
                $("#showroom-breadcrumbs").addClass("translate-dt-down");
                $("#showroom-introduction").addClass("translate-dt-down");
                $("#prevent-scrolling").addClass("prevent-scrolling");

            }, 500);
            setTimeout(function(){
                $("#showroom-slider").addClass("showroom-slider-open-arrow");
            }, 1500);
            setTimeout(function(){
                $("#showroom-slider-close").removeClass("hide");
            }, 1700);    
	});
});

//Close slider on close button press
$(document).ready(function () {
	$("#showroom-slider-close").on("click", function(e){
            e.preventDefault();
            $('.showroom-slide').css('margin-top', '-300px');
            $("#showroom-slider").removeClass("showroom-slider-open-arrow");
            $("#showroom-slider-close").addClass("hide");
            $("#showroom-slider").removeClass("showroom-slider-open");
            $("#header-desktop").removeClass("translate-dt-head-up");
            $("#showroom-slider").removeClass("translate-dt-head-up");
            $("#prevent-scrolling").removeClass("prevent-scrolling");
            setTimeout(function(){
                $("#header-desktop-inner-main").removeClass("hide-op");
                $("#showroom-breadcrumbs").removeClass("translate-dt-down");
                $("#showroom-introduction").removeClass("translate-dt-down");
            }, 800);
            setTimeout(function(){
                $("#showroom-slider-button").removeClass("hide-op");
            }, 900);
	});
});

// ---------- Sly Sliders ---------- //
// Store Page
(function () {
    var $frame = $('.showroom-sly-frame');

    // Call Sly on frame
    $frame.sly({
        horizontal: 1,
        itemNav: 'centered',
        itemSelector: ':visible',
        smart: true,
        activateOn: 'click',
        scrollBy: 1,
        mouseDragging: 1,
        touchDragging: 1,
        swingSpeed: 0.2,
        scrollBar: $('.scrollbar'),
        dragHandle: 1,
        speed: 600,
        startAt: 0
    });
    // Reload Sly on Resize 
    $(window).resize(function (e) {
        $frame.sly('reload');
    });
}());

// Category Page - Selector
(function () {
    var $frame = $('.category-selector-sly-frame');

    // Call Sly on frame
    $frame.sly({
        horizontal: 1,
        itemNav: 'centered',
        itemSelector: ':visible',
        smart: true,
        activateOn: 'click',
        scrollBy: 1,
        mouseDragging: 1,
        touchDragging: true,
        swingSpeed: 0.2,
        scrollBar: $('.scrollbar'),
        dragHandle: 1,
        speed: 600,
        startAt: 0
    });
    // Reload Sly on Resize 
    $(window).resize(function (e) {
        $frame.sly('reload');
    });
}());

// Category Page - Story
(function () {
    var $frame = $('.category-story-sly-frame');

    // Call Sly on frame
    $frame.sly({
        horizontal: 1,
        itemNav: 'centered',
        itemSelector: ':visible',
        smart: true,
        activateOn: 'click',
        scrollBy: 1,
        mouseDragging: 1,
        touchDragging: true,
        swingSpeed: 0.2,
        scrollBar: $('.scrollbar'),
        dragHandle: 1,
        speed: 600,
        startAt: 0
    });
    // Reload Sly on Resize 
    $(window).resize(function (e) {
        $frame.sly('reload');
    });
}());

// Scroll to Anchors //

$(".sliding-link").click(function (e) {
    e.preventDefault();
    var aid = $(this).attr("href");
    $('html,body').animate({ scrollTop: $(aid).offset().top }, 'slow');
});


// ---------- Comparison Table ---------- //
// DIRTY Responsive pricing table JS
// https://codepen.io/adrianjacob/pen/KdVLXY

$("ul").on("click", "li", function () {
    var pos = $(this).index() + 2;
    $("tr").find('td:not(:eq(0))').hide();
    $('td:nth-child(' + pos + ')').css('display', 'table-cell');
    $("tr").find('th:not(:eq(0))').hide();
    $('li').removeClass('active');
    $(this).addClass('active');
});

// Initialize the media query
var mediaQuery = window.matchMedia('(min-width: 840px)');

// Add a listen event
mediaQuery.addListener(doSomething);

// Function to do something with the media query
function doSomething(mediaQuery) {
    if (mediaQuery.matches) {
        $('.sep').attr('colspan', 4);
    } else {
        $('.sep').attr('colspan', 2);
    }
}

function doSomething(mediaQuery) {
    if (mediaQuery.matches) {
        $('.sep3').attr('colspan', 3);
    } else {
        $('.sep3').attr('colspan', 2);
    }
}

// On load
doSomething(mediaQuery);

// ---------- Comparison Table End ---------- //

// ---------- Tabbed Content ---------- //
$(document).ready(function () {
    $('.tabbed-content-chairs .tab_wrapper').champ();
})

$(document).ready(function () {
    $('.tabbed-content-beds .tab_wrapper').champ();
})


// ---------- Extras Be Last ---------- //
// Remove Bubble popup for standard HTML form validation
document.querySelector( "form" )
    .addEventListener( "invalid", function( event ) {
        event.preventDefault();
    }, true );


